import api from "./axios";

export const getWorkspaceStatsOverviewApi = () =>
    api.get("/admin/workspaces/stats/overview");

export const getWorkspaceActivationFunnelApi = () =>
    api.get("/admin/workspaces/stats/funnel");

export const listWorkspacesApi = (params = {}) =>
    api.get("/admin/workspaces/", { params });

export const getWorkspaceApi = (workspaceId) =>
    api.get(`/admin/workspaces/${workspaceId}`);

export const getWorkspaceMembersApi = (workspaceId) =>
    api.get(`/admin/workspaces/${workspaceId}/members`);

export const getWorkspaceInvitationsApi = (workspaceId) =>
    api.get(`/admin/workspaces/${workspaceId}/invitations`);

export const getWorkspacePropertiesApi = (workspaceId) =>
    api.get(`/admin/workspaces/${workspaceId}/properties`);

export const getWorkspaceIntegrationsApi = (workspaceId) =>
    api.get(`/admin/workspaces/${workspaceId}/integrations`);

export const getWorkspaceAuditEventsApi = (workspaceId, params = {}) =>
    api.get(`/admin/workspaces/${workspaceId}/audit-events`, { params });

export const listWorkspaceSubscriptionsApi = (params = {}) =>
    api.get("/admin/workspaces/subscriptions", { params });

export const listIntegrationHealthApi = (params = {}) =>
    api.get("/admin/workspaces/integration-health", { params });

export const assignWorkspacePlanApi = (workspaceId, payload) =>
    api.post(`/admin/workspaces/${workspaceId}/assign-plan`, payload);

export const grantWorkspaceQuotaApi = (workspaceId, payload) =>
    api.post(`/admin/workspaces/${workspaceId}/quota-grant`, payload);

export const cancelWorkspaceSubscriptionApi = (workspaceId, payload) =>
    api.post(`/admin/workspaces/${workspaceId}/cancel-subscription`, payload);

export const suspendWorkspaceApi = (workspaceId) =>
    api.post(`/admin/workspaces/${workspaceId}/suspend`);

export const activateWorkspaceApi = (workspaceId) =>
    api.post(`/admin/workspaces/${workspaceId}/activate`);

export const getWorkspaceDeletePreviewApi = (workspaceId) =>
    api.get(`/admin/workspaces/${workspaceId}/delete-preview`);

export const deleteWorkspaceApi = (workspaceId, payload) =>
    api.delete(`/admin/workspaces/${workspaceId}`, { data: payload });
